import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getMapOptions } from "../api/setup";
import { GoogleMapsGeocode } from "../api/googlemapsgeocode";

export interface Ihalfway {
    latLng?: google.maps.LatLngLiteral;
    startLatLng?: google.maps.LatLngLiteral;
    endLatLng?: google.maps.LatLngLiteral;
    term: string;
    totalDistance: number;
    geocode?: google.maps.GeocoderResult;
    locationName?: string;
    locationNameLong?: string;
}

interface ISetHalfway {
    latLng: google.maps.LatLngLiteral;
    startLatLng: google.maps.LatLngLiteral;
    endLatLng: google.maps.LatLngLiteral;
    term: string;
    totalDistance: number;
}

function initState(): Ihalfway {
    const mapoptions = getMapOptions();

    // the halfway has been precalculated!
    if (mapoptions.halfway) {
        //initialState.showDynamicMap = false;
        //console.log(mapoptions.halfway);

        let halfway: Ihalfway = {
            latLng: { lat: mapoptions.halfway.lat, lng: mapoptions.halfway.lng },
            totalDistance: mapoptions.halfway.distance,
            term: mapoptions.poi
        };

        // get the halfway location names
        if (mapoptions.halfway.geocoded) {
            halfway.geocode = JSON.parse(mapoptions.halfway.geocoded);

            const gc = new GoogleMapsGeocode(halfway.geocode);
            halfway.locationNameLong = halfway.geocode.formatted_address;
            halfway.locationName = gc.getGeocodeCityState();
        }
        else {
            halfway.locationNameLong = mapoptions.halfway.locationNameLong;
            halfway.locationName = mapoptions.halfway.locationName;
        }
        return halfway;
    }
    else {
        return {
            totalDistance: 0,
            term: mapoptions.poi
        };
    }
}

const halfwaySlice = createSlice({
    name: 'halfway',
    initialState: initState,
    reducers: {
        setlocationName(state: Ihalfway, action: PayloadAction<string>) {
            state.locationName = action.payload;
        },
        setlocationNameLong(state: Ihalfway, action: PayloadAction<string>) {
            state.locationNameLong = action.payload;
        },
        setHalfway(state: Ihalfway, action: PayloadAction<ISetHalfway>) {
            state.latLng = action.payload.latLng;
            state.startLatLng = action.payload.startLatLng;
            state.endLatLng = action.payload.endLatLng;
            state.term = action.payload.term;
            state.totalDistance = action.payload.totalDistance;
        }
    }
});

export const {
    setlocationName,
    setlocationNameLong,
    setHalfway
} = halfwaySlice.actions;

export default halfwaySlice.reducer;
